import { FirstMenu } from '../../models';
import { DBResults, R2Rule } from '../../models/abstract/rule.constant';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    // 获取菜单本数据
    async fetchDishBookList(params: FetchDishBookListParams, string_id: string): Promise<HttpSuccessOrErrorType<R2Rule>> {
        return await http.get(`/restaurant/${string_id}/rule/R2`, {
            params: {
                ...params
            }
        })
    },
    // 获取菜单本表格数据
    async fetchDishBookTableList(string_id: string): Promise<HttpSuccessOrErrorType<FirstMenu>> {
        return await http.get(`/restaurant/${string_id}/first_menus`)
    },
    // 根据id获取表格被选的菜单
    async fetchTableCheckedData(string_id: string, main_group_id: number): Promise<HttpSuccessOrErrorType<FirstMenu>> {
        return await http.get(`/restaurant/${string_id}/first_menus/${main_group_id}`)
    },
    // 根据id删除菜单本
    async deleteDishBook(string_id: string, rule_id: string): Promise<HttpSuccessOrErrorType<DBResults>> {
        return await http.delete(`/restaurant/${string_id}/rule/${rule_id}`)
    },
    //  复制菜单本
    async copyDishBook(string_id: string, params: DBResults): Promise<HttpSuccessOrErrorType<DBResults>> {
        return await http.post(`/restaurant/${string_id}/rule`, {
            value: params.value,
            code: params.code
        })
    },
    // 修改菜单本
    async modifyDishBook(string_id: string, params: DBResults): Promise<HttpSuccessOrErrorType<DBResults>> {
        return await http.patch(`/restaurant/${string_id}/rule/${params._id}`, {
            value: params.value,
            code: params.code
        })
    },
    // 创建菜单本
    async createDishBook(string_id: string, params: DBResults): Promise<HttpSuccessOrErrorType<DBResults>> {
        return await http.post(`/restaurant/${string_id}/rules `, {
            value: params.value,
            code: params.code
        })
    }
}

export type FetchDishBookListParams = {
    time?: string;
    category_name?: string;
    project_name?: string;
}